import script from "./AppPalette.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPalette.vue?vue&type=script&setup=true&lang=js"

import "./AppPalette.vue?vue&type=style&index=0&id=2c7883d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7883d0"]])

export default __exports__